import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";

export default function DropDownSelect({ choices, selected, onChange, label }) {

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: "none",
      color: "none",
      background: "none",
      borderColor: state.isFocused ? "none" : "none",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "none" : "none"
      }
    }),
    placeholder: provided => ({
      ...provided,
      color: "black",
      fontWeight: "normal",
      fontSize: "normal",
      width: "fit-content",
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: "black",
      border: "none",
      paddingLeft: "0px",
    }),
    indicatorSeparator: () => (null),
    option: provided => ({
      ...provided,
      color: "black"
    }),
    menu: base => ({
      ...base,
      borderRadius: 2,
      marginTop: 0
    }),
    menuList: base => ({
      ...base,
      padding: 0
    })
  };

  return (
    <div className="dropdown">
      {label && <label>{label}</label>}
      <Select
        styles={customStyles}
        className="select"
        options={choices}
        onChange={onChange}
        value={selected}
        placeholder={selected}
      />
    </div>
  );
}

DropDownSelect.propTypes = {
  choices: PropTypes.array.isRequired,
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string
};
